import { store } from "@/vuex/store.js";
import { axiosPost } from "../apiCallers/options/header";
import permissioner from "../services/permissioner";

async function uploadViaBackend(groupId, folderId, files) {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file);
  });
  formData.append("groupId", groupId);
  formData.append("sid", folderId);
  formData.append("token", store.state.aToken);

  return axiosPost(
    process.env.VUE_APP_API_ENDPOINT_STARTER + "/cases/test-file",
    formData
  );
}

export async function uploadFiles(
  groupId,
  folderId,
  files,
  defaultTag,
  activeTag
) {
  const successfulUploads = [];
  const unsuccessfulUploads = [];
  await permissioner.getLoggedInUser();

  let response;
  try {
    response = await uploadViaBackend(groupId, folderId, files);
  } catch (error) {
    files.forEach((file) => {
      unsuccessfulUploads.push({ name: file.name, error });
    });
    return { successfulUploads, unsuccessfulUploads };
  }

  const uploadedFiles = (response.data && response.data.uploadedFiles) || [];

  files.forEach((file) => {
    const tag = file.tag || defaultTag || activeTag;
    const uploaded = uploadedFiles.find(u => u && u.originalName === file.name);
    if (uploaded && uploaded.id) {
      successfulUploads.push({
        name: file.name,
        id: uploaded.id,
        tag,
      });
    } else {
      successfulUploads.push({
        name: file.name,
        id: null,
        tag,
      });
      console.warn("[FileTagUploader] No file ID resolved for:", file.name);
    }
  });

  return { successfulUploads, unsuccessfulUploads };
}
